/*
 * @Description:
 * @Author: 姓名
 * @Date: 2025-03-31 17:38:12
 * @LastEditTime: 2025-04-10 17:44:24
 * @LastEditors: caoran
 */
import React, { useEffect, useMemo, useState } from 'react'
import { Input, Popover } from 'antd'
import {
  useAiChatDrawer,
  useAppDispatch,
  useAppSelector
} from '../../../app/hooks'
import './index.scss'
import { getAgentAIList } from '../../../actions/aiChat'
import allow_left from '../../../images/ai-chat/allow_left.png'
import send_blue from '../../../images/ai-chat/send_blue.png'
import send_grey from '../../../images/ai-chat/send_grey.png'
import sensors from '../../../utils/sensors'
import { CloseOutlined } from '@ant-design/icons'

interface AiImageRegModalProps {
  clickNode: any
  image: string
  nodeClassName: string
  fromPlace: string
}

const AiImageRegModal = (props: AiImageRegModalProps) => {
  const { clickNode, image, nodeClassName, fromPlace } = props
  const aiChatDrawer = useAiChatDrawer()
  const dispatch = useAppDispatch()
  const userID = useAppSelector((state) => state.main.user?.user_id)
  const [popoverVisible, setPopoverVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [agentInfo, setAgentInfo] = useState({
    pre_questions: []
  })

  const handleSensorEvent = (actionType, params) => {
    sensors.track('web_get_action_ai_photo_identify', {
      actionType,
      fromPlace: fromPlace,
      photoFilename: image,
      ...params
    })
  }

  const openAiChat = (info) => {
    setPopoverVisible(false)
    const questionInfo = info
    aiChatDrawer.open({
      questionInfo,
      referenceImage: image,
      agentInfo: { ...agentInfo },
      handleSensorEvent: handleSensorEvent
    })
  }

  useEffect(() => {
    if (popoverVisible) {
      handleSensorEvent('showPop', { pageType: 1 })
      handleGetAgentAIList()
    } else {
      setInputValue('')
      handleSensorEvent('closePop', { pageType: 1 })
    }
  }, [popoverVisible])

  useEffect(() => {}, [agentInfo])

  const handleGetAgentAIList = async () => {
    try {
      const res = await dispatch(
        getAgentAIList({
          userID: userID,
          source: 1
        })
      )
      const agent = res.ai_agents[0]
      let historyQuestions = localStorage.getItem('historyQuestionData')
      if (historyQuestions) {
        agent.pre_questions = [
          ...JSON.parse(historyQuestions),
          ...agent?.pre_questions
        ].slice(0, 2)
      }
      if (!historyQuestions || historyQuestions === '[]') {
        localStorage.setItem(
          'historyQuestionData',
          JSON.stringify(agent.pre_questions || [])
        )
      }
      setAgentInfo(agent)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Popover
        classNames={{ root: 'ai-image-reg-modal' }}
        content={
          <div
            className="popover-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popover-title">
              <div className="popover-title-left">AI识图提问</div>
              <div
                className="popover-title-right"
                onClick={() => setPopoverVisible(false)}
              >
                <CloseOutlined />
              </div>
            </div>
            <div className="popover-content">
              <div className="popover-content-left">
                <img src={image} alt="" />
              </div>
              <div className="popover-content-right">
                {agentInfo.pre_questions.map((item, index) => (
                  <div className="question-wrapper" key={index}>
                    <div
                      className="question"
                      key={index}
                      onClick={() => {
                        handleSensorEvent('clickContent', {
                          pageType: 1,
                          string1: item
                        })
                        openAiChat({ content: item, contentType: 1 })
                      }}
                    >
                      {item}
                    </div>
                    <img src={allow_left} alt="" />
                  </div>
                ))}
              </div>
            </div>
            {popoverVisible && (
              <Input
                placeholder="请输入你想问的问题"
                autoFocus
                maxLength={500}
                onChange={(e) => {
                  const value = e.target.value.trim()
                  setInputValue(value)
                }}
                suffix={
                  <img
                    src={inputValue.length > 0 ? send_blue : send_grey}
                    alt=""
                    style={{ cursor: 'pointer', height: '28px', width: '28px' }}
                    onClick={() => {
                      if (inputValue.length > 0) {
                        handleSensorEvent('clickSend', {
                          pageType: 1,
                          string1: inputValue
                        })
                        openAiChat({ content: inputValue, contentType: 1 })
                        setPopoverVisible(false)
                      }
                    }}
                  />
                }
              />
            )}
          </div>
        }
        title=""
        trigger="click"
        open={popoverVisible}
        onOpenChange={(e) => setPopoverVisible(!popoverVisible)}
      >
        <div
          className={nodeClassName}
          onClick={(e) => {
            e.stopPropagation()
            console.log('onClick')
          }}
        >
          {clickNode}
        </div>
      </Popover>
    </>
  )
}

export default AiImageRegModal
